import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import s from './HistoryParametersHeader.css';
import Messages from './Messages';
import Button from '../Button';
import Icon from '../Icon';
import Loader from '../Loader';

class HistoryParametersHeader extends React.Component {
  getHeaderColor = deviceType => {
    const isSuperior = deviceType === 'superior';
    const colorStyled = isSuperior ? cx(s.blackButton) : cx(s.whiteButton);
    const dark = isSuperior ? "dark_spirotech" : "dark" ;
    const light = isSuperior ? "light_spirotech" : "light";
    const edytuj = isSuperior ? "edytuj_black" : "edytuj";
    const clearFilter = isSuperior ? 'odrzuc' : 'odrzuc_white';
    return { colorStyled, dark, light, edytuj, clearFilter };
  };

  render() {
    const { deviceType, deviceDocumentPaging, deviceName, deviceSerial } = this.props;
    const messages = Messages();
    const iconSize = 41;
    const {
      colorStyled,
      dark,
      light,
      edytuj,
      clearFilter,
    } = this.getHeaderColor(deviceType);

    const downloadingDocument = deviceDocumentPaging.get('downloadingDocument');

    return (
      <section className={s.container}>
        <div className={s.left}>
          <h3>{deviceName} S/N: {deviceSerial}</h3>
        </div>
        <div className={s.right}>
          <Button
            onClick={() => {
              if (!downloadingDocument) {
                this.props.onSave();
              }
            }}
            buttonClass="mainPdf"
            buttonColor={dark}
          >
            <Icon iconName={edytuj} size={iconSize} />
            <div className={colorStyled}>
              {!downloadingDocument ? (
                <FormattedMessage {...messages.save_as_pdf_button_history} />
              ) : (<Loader/>)}
            </div>
          </Button>
          <Button
            onClick={() => {
              this.props.onClearFilter();
            }}
            buttonClass="mainPdf"
            buttonColor={light}
          >
            <Icon iconName={clearFilter} size={iconSize} />
            <div className={colorStyled}>
              {!downloadingDocument ? (
                <FormattedMessage {...messages.clear_filter_button_history} />
              ) : (<Loader/>)}
            </div>
          </Button>
        </div>
      </section>
    );
  }
}

HistoryParametersHeader.propTypes = {
  onSave: PropTypes.func.isRequired,
  onClearFilter: PropTypes.func.isRequired,
  deviceType: PropTypes.string.isRequired,
  deviceName: PropTypes.string.isRequired,
  deviceSerial: PropTypes.string.isRequired,
};

export default withStyles(s)(HistoryParametersHeader);



// WEBPACK FOOTER //
// ./src/components/HistoryParameters/HistoryParametersHeader.js